import React, { useEffect, useState } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useToast,
} from "@chakra-ui/react";

export default function CustomRangeModal({
  isOpen,
  onClose,
  onApplyCustomRange,
  initialFrom,
  initialTo,
  texts,
}) {
  const toast = useToast();
  const [fromDate, setFromDate] = useState(initialFrom);
  const [toDate, setToDate] = useState(initialTo);

  useEffect(() => {
    setFromDate(initialFrom);
    setToDate(initialTo);
  }, [initialFrom, initialTo, isOpen]);

  const handleApply = () => {
    if (!fromDate || !toDate) {
      toast({
        title: texts.reports?.validationError || "Validation Error",
        description:
          texts.reports?.bothDatesRequired ||
          "Both From and To dates are required.",
        status: "error",
        duration: 2000,
      });
      return;
    }

    if (new Date(fromDate) > new Date(toDate)) {
      toast({
        title: texts.reports?.dateError || "Date Error",
        description:
          texts.reports?.fromDateAfterToDate ||
          "The 'From' date cannot be after the 'To' date.",
        status: "warning",
        duration: 2000,
      });
      return;
    }

    onApplyCustomRange({ from_date: fromDate, to_date: toDate });
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="sm">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader p={3}>
          {texts.reports?.customRange || "Custom range"}
        </ModalHeader>
        <ModalBody p={3}>
          <HStack spacing={1}>
            <FormControl isRequired>
              <FormLabel fontSize="xs">{texts.reports?.from || "From"}*</FormLabel>
              <Input
                type="date"
                value={fromDate}
                onChange={(event) => setFromDate(event.target.value)}
                size="xs"
              />
            </FormControl>
            <FormControl isRequired>
              <FormLabel fontSize="xs">{texts.reports?.to || "To"}*</FormLabel>
              <Input
                type="date"
                value={toDate}
                onChange={(event) => setToDate(event.target.value)}
                size="xs"
              />
            </FormControl>
          </HStack>
        </ModalBody>
        <ModalFooter p={3}>
          <Button variant="ghost" mr={2} onClick={onClose} size="xs">
            {texts.reports?.cancel || "Cancel"}
          </Button>
          <Button colorScheme="blue" onClick={handleApply} size="xs">
            {texts.reports?.apply || "Apply"}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
